import { useWindowSize } from "components/hooks/useWindowSize";
import PDFViewer from "components/layout/PDFViewer";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useFetchIncidentReport } from "../hooks/BinaryContentReportHooks";
import { CenteredBusySpinner } from "components/layout/overlay/components/CenteredBusySpinner";

export function IncidentReportDialog({ id, selectedReportType, onClose }) {
    const [width, height] = useWindowSize();
    const { data, isLoading } = useFetchIncidentReport(id, selectedReportType);

    return (
        <Dialog width={width} height={height}>
            {isLoading ? (
                <CenteredBusySpinner />
            ) :
                (<div style={{ height: "100%" }}>
                    <PDFViewer
                        data={{
                            fileName: `${data.fileName}`.toLowerCase(),
                            base64: data.content,
                        }}
                        onCloseClick={onClose}
                    />
                </div>)
            }
        </Dialog>
    );
}
